import { ReactElement } from 'react';
import ForceFlagControl, { ForceFlagControlProps } from './ForceFlagControl';

/**
 * Editor for `parser_vars.gps.force_gps_speed` — on reprocess the run's speed
 * comes from GPS, overriding the calibration's and the device's ground-speed
 * setup. A logged wheel sensor rides along for comparison.
 */
export default function ForceGpsSpeedControl(props: ForceFlagControlProps): ReactElement {
  return (
    <ForceFlagControl
      {...props}
      id="force-gps-speed"
      label="Force GPS speed"
      hint="Reprocess takes the run's speed from GPS, whatever the speed sensor setup says"
    />
  );
}
